<template>
  <div>
    <section id="basic-datatable">
      <div class="row">
        <div class="col-12">
          <div class="text-right">
            <button type="button" class="btn btn-primary mb-1" style="margin-right: 2em" @click="inviteAdminModal()">
              <iconify-icon icon="ic:baseline-plus" height="22px"
                style="transform: translate(5px, 5px);"></iconify-icon>
              <span class=" ml-25">{{ $t('user_management_module_add_user_button') }}</span>
            </button>
          </div>
          <div class="card" style="padding-right: 2em; padding-left: 2em">
            <div class="card-content" style="border:1px solid #DFE3E7;">
              <div class="card-header">
                <h5 class="card-title headingStyleUser">{{ $t('user_management_module_data_table_heading') }}</h5>
                <div class="heading-elements" style="margin-right: 2.5em">
                  <ul class="list-inline mb-0">
                    <li class="listSize" style="margin-right: 1em ">
                      <legend>
                        <select class="form-control mr-1" v-model="statusFilter" @change="filterByData()">
                          <option selected value="default">{{ $t('users_module_filter_select_status') }}</option>
                          <option value="joined"> {{ $t('users_module_filter_active_status') }} </option>
                          <option value="banned"> {{ $t('users_module_filter_inactive_status') }} </option>
                          <option value="invited"> {{ $t('users_module_filter_invite_status') }} </option>
                        </select>
                      </legend>
                    </li>
                    <li class="listSize">
                      <legend class="has-icon-left">
                        <select class="form-control mr-1" v-model="searchFilter" @change="findByEmailModal()">
                          <option selected disabled value="default">{{ $t('users_module_search_search_by') }}</option>
                          <option value="all"> {{ $t('users_module_search_all_users') }}</option>
                          <option value="email"> {{ $t('users_module_search_search_by_email') }} </option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-search font-medium-1"></em>
                        </div>
                      </legend>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body card-dashboard">
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                    <span class="sr-only">{{ $t('common_module_loader_label') }}</span>
                  </div>
                </div>
                <div class="text-center mt-1" v-if="!cloUsers.length && !loadingData">
                  <p>{{ $t('common_module_label_users_not_found') }}</p>
                </div>
                <div class="table-responsive tableStyle" style="border: 0px solid;" v-if="cloUsers.length">
                  <table class="table zero-configuration" aria-describedby="clo user list" style="margin-bottom: 1em">
                    <thead style="border: 1px solid #DFE3E7;">
                      <tr>
                        <th class="tableNames tableNameStyle">{{ $t('users_management_module_datatable_name') }}</th>
                        <th class="tableNames tableRoleStyle">{{ $t('users_management_module_datatable_role') }}</th>
                        <th class="tableNames tableMailStyle">{{ $t('users_management_module_datatable_email') }}</th>
                        <th class="tableNames tableNumberStyle">{{ $t('users_management_module_datatable_number') }}
                        </th>
                        <th class="tableNames">{{ $t('users_management_module_datatable_country') }}</th>
                        <th class="tableNames">{{ $t('users_management_module_datatable_status') }}</th>
                        <th class="tableNames">{{ $t('users_management_module_datatable_action') }}</th>
                      </tr>
                    </thead>
                    <tbody style="border: 1px solid #DFE3E7;">
                      <tr v-for="item in cloUsers">
                        <td class="capitalize">
                          <span class=" nameSpan" v-if="item.name">{{ item.name }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span v-if="item.type">
                            <span class="nameSpan" v-if="item.type == 'project_manager'"> {{
                              $t('clo_user_add_user_popup_role_dropdown_project_manager_option')
                            }}</span>
                            <span class="nameSpan" v-if="item.type == 'cloowner'"> {{
                              $t('clo_user_add_user_popup_role_dropdown_organization_admin_option')
                            }}</span>
                            <span class="nameSpan" v-if="item.type == 'clopacto_user_success_lead'"> {{
                              $t('clo_user_add_user_popup_role_dropdown_pacto_user_success_lead_option')
                            }}</span>
                            <span class="nameSpan" v-if="item.type == 'complaint_feedback_lead'"> {{
                              $t('clo_user_add_user_popup_role_dropdown_complaints_and_feedback_lead_option')
                            }}</span>
                          </span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="nameSpan" v-if="item.email">{{ item.email }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="nameSpan" v-if="item.phoneNumber">{{ item.phoneNumber }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span v-if="item.country">{{ countryName(item.country) }}</span>
                          <span v-else>-</span>
                        </td>
                        <td class="capitalize statusDiv">
                          <span v-if="item.status == 'joined'" style="margin-left: 1em;">
                            <em class="bx bxs-circle success font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_active_status') }}</span>
                          </span>
                          <span v-else-if="item.status == 'invited'" style="margin-left: 1em;">
                            <em class="bx bxs-circle info font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_invite_status') }}</span>
                          </span>
                          <span v-else style="margin-left: 1em;">
                            <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_inactive_status') }}</span>
                          </span>
                        </td>
                        <td>
                          <div class="imageStyle">

                            <img :src="viewImage" class="iconStyle mr-1" :alt="$t('error_message_for_loading_image')"
                              z>
                            <img v-if="item.status != 'invited'" :src="editImage"
                              :alt="$t('error_message_for_loading_image')" class="iconEditStyle mr-1 cursor-pointer"
                              @click="editUserModal(item.id, orgId)">
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--      Find by Email Modal-->
    <div class="modal fade text-left" id="find-by-email-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modalStyle" v-if="searchFilter == 'email'">
          <div class="modal-header">
            <h3 class="modal-title " id="create-modal-title" v-if="searchFilter == 'email'">{{
              $t('users_module_search_popup_heading_search_by_email')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x" @click="closeModal()"></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert :text="$t('pacto_users_module_validation_email_error')" type="danger" dismbissable="false"
              v-if="emailSearchError" />
            <form>
              <div class="form-group row" v-if="searchFilter == 'email'">
                <div class="col-md-12 col-sm-12">
                  <label>{{ $t('users_module_search_popup_label_email') }}</label>
                  <input type="email" class="form-control searchInput"
                    :placeholder="$t('users_module_search_popup_placeholder_email')" v-model="emailSearch"
                    @keyup="emailValidation" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modalFooter" v-if="searchFilter == 'email'">
            <button type="button" class="btn btn-primary ml-1" aria-label="Close" @click="findByEmail()"
              :disabled="!emailSearch">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block" v-if="searchFilter == 'email'">{{
                $t('users_module_search_popup_search_by_email_search_button')
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Invite Admin Modal -->
    <div class="modal fade text-left" id="invite-admin-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modalStyle">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title headingAddUserStyle">{{
              $t('clo_user_add_user_popup_heading')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close" @click="cancel()">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body ">
            <Alert :text="inviteErrorText" type="danger" dismissable="false" v-if="error" />
            <Alert :text="$t('clo_user_add_popup_required_validation')" type="danger" dismbissable="false"
              v-if="requiredError" />
            <form action="#">
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('clo_user_add_user_popup_name_label') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('clo_user_add_user_popup_name_placeholder')"
                    v-model="name" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('clo_user_add_user_popup_role_label') }}</label>
                  <select class="form-control" v-model="role">
                    <option selected value="default">{{ $t('clo_user_add_user_popup_role_popup_default_value') }}
                    </option>
                    <option value="cloowner">{{ $t('clo_user_add_user_popup_role_dropdown_organization_admin_option') }}
                    </option>
                    <option value="project_manager">{{
                      $t('clo_user_add_user_popup_role_dropdown_project_manager_option')
                    }} </option>
                    <option value="clopacto_user_success_lead">{{
                      $t('clo_user_add_user_popup_role_dropdown_pacto_user_success_lead_option')
                    }} </option>
                    <option value="complaint_feedback_lead">{{
                      $t('clo_user_add_user_popup_role_dropdown_complaints_and_feedback_lead_option')
                    }} </option>
                  </select>
                </div>
              </div>
              <div class="form-group row ">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('clo_user_add_user_popup_email_label') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('clo_user_add_user_popup_email_placeholder')"
                    v-model="email" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('clo_user_add_user_popup_phone_label') }}</label>
                  <PhoneNumberInput :phoneNumber="phoneNumber" :onCountryCodeSelect="onCountryCodeSelect"
                    :onPhoneNumberChange="onPhoneNumberChange"
                    :placeholder="$t('clo_user_add_user_popup_phone_placeholder')"
                    addClass="form-control inputTabData" />
                </div>
              </div>
              <div class="form-group row ">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('clo_user_add_user_popup_status_dropdown_label') }}</label>
                  <select class="form-control " v-model="statusData">
                    <option value="default">{{ $t('clo_user_add_user_popup_status_dropdown_default') }}</option>
                    <option value="joined"> {{ $t('clo_user_status_dropdown_active_option') }} </option>
                    <option value="banned"> {{ $t('clo_user_status_dropdown_inactive_option') }} </option>
                  </select>
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('clo_user_add_user_popup_country_label') }}</label>
                  <select class="form-control mr-1" v-model="countryInfo">
                    <option value="default" disabled>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                    </option>
                    <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                      countryName(country)
                    }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer footerClass">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" @click="cancel()">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_view_cancel_button') }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="addUsers()">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_add_popup_add_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    Invite Successfull modal-->
    <div class="modal fade text-left" id="invite-success-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg modalPopStyle" role="document">
        <div class="modal-content resetPasswordDialogue">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
              $t('users_module_invite_success_popup_heading')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title resetPasswordSuccessHeading divStyleModal" id="create-modal-title">{{
              $t('users_module_success_invitation_popup_message')
            }}</h3>
          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block " style="color: white">{{
                $t('users_module_invitation_success_popup_cancel_button')
              }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_module_invitation_success_popup_ok_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import Alert from '@/components/Alerts'
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";

export default {
  name: "CLOUsersPage",
  props: ['orgId'],
  data() {
    return {
      cloUsers: [],
      loadingData: true,
      activeCountries: [],
      statusFilter: "default",
      searchFilter: "default",
      viewImage: require('@/assets/Vector.png').default,
      editImage: require('@/assets/editing.png').default,
      closeImage: require('@/assets/close.png').default,
      role: 'default',
      name: '',
      email: '',
      statusData: 'default',
      countryInfo: 'default',
      phoneNumber: '',
      requiredError: false,
      error: false,
      dialCode: '',
      orgId: this.$route.params.org,
      totalCountries: [],
      language: localStorage.getItem('defaultLanguage'),
      emailSearch: ''
    }
  },

  components: {
    Alert,
    PhoneNumberInput
  },
  methods: {
    getAdmins() {
      let self = this;
      self.loadingData = true;
      this.$apiCall.get(`v1/clo/${self.orgId}/admins`).then((response) => {
        self.loadingData = false;
        self.loadingData = false;
        self.cloUsers = response.data.data;
        self.initDataTable();
      });
    },
    getAllAdmins() {
      let self = this;
      self.loadingData = true;
      this.$apiCall.get(`v1/clo/${self.orgId}/admins`).then((response) => {
        self.loadingData = false;
        self.loadingData = false;
        self.cloUsers = response.data.data;
      });
    },
    getCountryData() {
      let self = this;
      this.$apiCall.get(`v1/clo-organization/${self.orgId}/countries`).then(function (response) {
        self.totalCountries = response.data
      })
    },
    initDataTable() {
      setTimeout(function () {
        $.fn.dataTableExt.sErrMode = 'throw';
        $(".zero-configuration").DataTable({
          "bLengthChange": false,
          "bPaginate": true,
          "bFilter": false,
          "order": [],
          "data": this.cloUsers,
        });

      }, 100);
    },
    filterByData() {
      let self = this;
      self.cloUsers = [];
      self.loadingData = true;
      let filterData = {};
      if (self.statusFilter != "default") {
        filterData.status = self.statusFilter;
      }

      if (filterData.status) {
        self.filterApiCall(filterData)
      }
      else {
        self.cloUsers = []
        self.getAdmins();
      }
    },

    filterApiCall(data) {
      let self = this;
      self.$apiCall
        .get(`v1/clo/${self.orgId}/admins`, { params: data })
        .then(response => {
          self.loadingData = false;
          self.cloUsers = response.data.data;
          self.initDataTable();
        })
    },
    findByEmailModal() {
      if (this.searchFilter == "all") {
        let self = this;
        self.getAdmins()
        self.searchFilter = 'default';
        self.statusFilter = 'default'
      } else {
        self.findModal = true;
        if (self.findModal) {
          $("#find-by-email-modal").modal()
        }
      }
    },
    emailValidation() {
      let self = this;
      if (this.$filters.validateEmail(self.emailSearch)) {
        self.emailSearchError = false;
      } else {
        self.emailSearchError = true;
      }
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
    findByEmail() {
      let self = this;
      if (!self.emailSearchError) {
        self.cloUsers = [];
        this.$apiCall.get(`/v1/admins/email/${self.emailSearch}`).then(function (response) {
          $("#find-by-email-modal").modal("hide");
          self.cloUsers.push(response.data)
          self.findModal = false;
          self.loadingData = false;
          self.emailSearch = '';
          self.searchFilter = 'default';
        }).catch(error => {
          self.emailSearch = ''
          self.loadingData = false
          self.searchFilter = 'default';
        })
      }
    },
    closeModal() {
      $("#find-by-email-modal").modal("hide");
      let self = this;
      self.emailSearchError = false;
      self.emailSearch = '';
      self.searchFilter = 'default';

    },
    viewUserModal(uid, org) {
      this.$router.push({ name: 'ViewCLOUserPage', params: { org: org, uid: uid } });
    },
    editUserModal(uid, org) {
      let self = this;
      self.editValue = true;
      localStorage.setItem('editValue', self.editValue)
      self.$router.push({ name: 'EditCLOUserPage', params: { org: org, uid: uid } });
    },
    inviteAdminModal() {
      this.inviteErrorText = ''
      this.error = false;
      $("#invite-admin-modal").modal();
    },
    sucessAdminModal() {
      this.inviteErrorText = ''
      this.error = false;
      $("#invite-success-modal").modal();
    },
    validateFields() {
      let self = this;
      if (self.language == "English") {
        self.language = "en"
      }
      if (self.name != "") {
        self.requiredError = false
      } else {
        self.requiredError = true
      }

      if (self.email != "") {
        self.requiredError = false
      } else {
        self.requiredError = true
      }
      if (self.phoneNumber != "") {
        self.requiredError = false
      } else {
        self.requiredError = true
      }
      if (self.role != "default") {
        self.requiredError = false
      } else {
        self.requiredError = true
      }
      if (self.countryInfo != "default") {
        self.requiredError = false
      } else {
        self.requiredError = true
      }
      if (self.statusData != "default") {
        self.requiredError = false
      } else {
        self.requiredError = true
      }
    },
    addUsers() {
      let self = this;
      self.validateFields()
      if (!self.requiredError) {
        let pN = "+" + self.dialCode + self.phoneNumber.replace(`+${self.dialCode}`, "");
        if (self.phoneNumber != "" || self.email.trim() != "") {
          let block_ele = $("#invite-admin-modal .modal-content");
          $(block_ele).block({
            message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
            overlayCSS: {
              backgroundColor: "#fff",
              opacity: 0.8,
              cursor: "wait",
            },
            css: {
              border: 0,
              padding: 0,
              backgroundColor: "transparent",
            },
          });
          this.$apiCall
            .post("/v1/admins/invite", {
              email: (self.email.trim() != "") ? self.email.trim() : null,
              name: self.name,
              phoneNumber: (self.phoneNumber != "") ? pN : null,
              type: self.role,
              status: self.statusData,
              country: self.countryInfo,
              language: self.language

            })
            .then((response) => {
              $(block_ele).unblock();
              self.phoneNumber = "";
              self.name = "";
              self.email = "";
              self.status = "default"
              self.countryInfo = "default"
              self.role = "default";
              $("#invite-admin-modal").modal("hide");
              this.sucessAdminModal()
              self.cloUsers = [];
              self.getAllAdmins();
            })
            .catch((error) => {
              $(block_ele).unblock();
              self.error = true;
              self.inviteErrorText =
                error.response.status == 406 | 405
                  ? "Ops! These invitation data <strong>already exist</strong>"
                  : `<strong>Ops!</strong> ${error.response.data.message}`;
            });
        }
      }
    },
    cancel() {
      let self = this;
      self.name = '';
      self.role = 'default';
      self.email = '';
      self.statusData = 'default';
      self.phoneNumber = '';
      self.countryInfo = 'default';
      self.requiredError = false;
    },
    onCountryCodeSelect({ name, iso2, dialCode }) {
      this.dialCode = dialCode
    },
    onPhoneNumberChange(value) {
      this.phoneNumber = value;
    },
  },
  mounted() {
    this.getCountryData();
    this.getAdmins();

  }
}
</script>

<style scoped>
.tableNames {
  font-size: 1rem
}

.tableStyle {
  border: 1px solid #DFE3E7;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px 4px 0px 0px;
}

.iconEditStyle {
  height: 15px;
  width: 16px;
  transform: translate(8px, 0px);
  cursor: pointer;
}

.iconStyle {
  width: 22px;
  transform: translate(6px, 13px);
  cursor: pointer;
}

.modalStyle {
  width: 733px;
  margin-top: 20.5em;
  border-radius: 10px;
  margin-left: 10em;
}

.imageStyle {
  display: flex;
  align-items: center;
}

.headingAddUserStyle {
  color: #4A0A1E !important;
}

.marginDiv {
  display: flex;
}

.statusDiv {
  padding: 1.15rem 1rem;
}

.inputTabData {
  height: 2.5em;
  width: 21em;
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
}

.vue-tel-input.form-control.inputTabData:focus-within {
  color: #475F7B;
  background-color: #FFFFFF;
  border-color: #5A8DEE;
  outline: 0;
  box-shadow: 0 3px 8px 0 rgb(0 0 0 / 10%);
}

.flagAlign {
  transform: translate(0em, -33px);
  border: 0px;
}

.divStyle {
  margin-top: -2em;
}

.footerClass {
  border-top: 1px solid #DFE3E7;
}

.headingStyleUser {
  color: #475F7B
}

@media(max-width:1366px) {
  .modalStyle {
    width: 733px;
    margin-top: 7.5em;
    border-radius: 10px;
    margin-left: 8em;
  }

}
</style>
